import { createStore, combineReducers } from "redux";
import { userReducer } from "./Store/userReducer";

const rootReducer = combineReducers({
  user: userReducer,
});

export const store = createStore(rootReducer);